var root = require('./_root');

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-color/node_modules/lodash/_coreJsData.js
// module id = 1176
// module chunks = 0